// バックエンド（service）の API のパスの一覧です。
// ここに書かれていないものについては portal/src/config/config.ts を参照してください。
//
// パスが 1 ファイルにまとまっているほうが、API 呼び出しを行うコードを探しやすくなるかと思い、このファイルにまとめています。
export const apiPaths = {
  nonces: "/nonces",
  login: "/login",
  loginPasscodes: "/login_passcodes",
};
